import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";
import { useLocation } from "react-router-dom";
import "./SchemeCashReceiptMob.css";
import sslogo from "../../../assets/images/ssMob.png";
import ComboBox from "../../../../src/components/ComboBoxes/ComboBox";
import save from "../../../assets/images/SaveImage.png";
import find from "../../../assets/images/findMob.png";
import edit from "../../../assets/images/Editing.png";
import Delete from "../../../assets/images/Delete.png";
import print from "../../../assets/images/Printer.png";
import close from "../../../assets/images/findclose.png";
import home from "../../../assets/images/arrow.png";
import clear from "../../../assets/images/Document.png";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import { useDbContext } from "../../../context/DbContext";
import io from "socket.io-client";
import { useSelector, useDispatch } from "react-redux";
import { selectMenuPermissions } from "../../../app/permissionsSlice";
import { selectGeneralSettings } from "../../../app/settingsSlice";
import { selectActiveFyid, fetchActiveFinancialYear } from "../../../app/financialYearSlice";
import { selectActiveLocation } from "../../../app/locationSlice";
import { useActiveFyLimits } from "../../../utils/fyDateValidation";
import FormDesign, { FormDesignProvider, useFormDesign } from "../../FormDesign/FormDesign";
import { ToWords } from "to-words";
import Swal from "sweetalert2";
import { printWithTemplate, clearPrintTemplateCache } from "../../../hooks/usePrintService";

const defaultSchemeFormFields = [
  // ── Header Fields ──
  {
    fieldId: "EntryNo",
    fieldName: "Entry No",
    tabIndex: 0,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "SchemeName",
    fieldName: "Scheme Name",
    tabIndex: 1,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "CashAccount",
    fieldName: "Cash Account",
    tabIndex: 2,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Select",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Rate",
    fieldName: "Rate",
    tabIndex: 3,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "Date",
    fieldName: "Date",
    tabIndex: 4,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Date",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Grid ──
  {
    fieldId: "Grid",
    fieldName: "Scheme Receipt Grid",
    tabIndex: 5,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Grid",
  },
  // ── Action Toolbar Buttons ──
  {
    fieldId: "SaveBtn",
    fieldName: "Save",
    tabIndex: 25,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "PrintBtn",
    fieldName: "Print",
    tabIndex: 26,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ClearBtn",
    fieldName: "Clear",
    tabIndex: 27,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "FindBtn",
    fieldName: "Find",
    tabIndex: 28,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "EditBtn",
    fieldName: "Edit",
    tabIndex: 29,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "DeleteBtn",
    fieldName: "Delete",
    tabIndex: 30,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  {
    fieldId: "ExitBtn",
    fieldName: "Exit",
    tabIndex: 31,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Button",
    fontSize: 11,
    fontStyle: "Normal",
  },
  // ── Grid Inputs ──
  {
    fieldId: "grid_AccountNumber",
    fieldName: "Grid - Account Number",
    tabIndex: 6,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Text",
  },
  {
    fieldId: "grid_Amount",
    fieldName: "Grid - Amount",
    tabIndex: 7,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Disc",
    fieldName: "Grid - Disc",
    tabIndex: 8,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Total",
    fieldName: "Grid - Total",
    tabIndex: 9,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Gm",
    fieldName: "Grid - Gm",
    tabIndex: 10,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_DiscGm",
    fieldName: "Grid - Disc Gm",
    tabIndex: 11,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_TotalGm",
    fieldName: "Grid - Total Gm",
    tabIndex: 12,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Number",
  },
  {
    fieldId: "grid_Narration",
    fieldName: "Grid - Narration",
    tabIndex: 13,
    defaultValue: "",
    visible: true,
    enabled: true,
    checked: false,
    type: "Text",
  },
  // ── Breakout / Row-Break Config Pseudo-Fields ──
  {
    fieldId: "__GridBreakoutColumn",
    fieldName: "Grid Breakout Column",
    tabIndex: 9999,
    defaultValue: "AccountNumber",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridBreakoutTarget",
    fieldName: "Grid Breakout Target",
    tabIndex: 9999,
    defaultValue: "SaveBtn",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakColumn",
    fieldName: "Grid Row-Break Column",
    tabIndex: 9999,
    defaultValue: "Narration",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
  {
    fieldId: "__GridRowBreakTarget",
    fieldName: "Grid Row-Break Target",
    tabIndex: 9999,
    defaultValue: "AccountNumber",
    visible: false,
    enabled: false,
    checked: false,
    type: "Config",
  },
];

function SchemeCashReceiptInnerMob({
  formId: propFormId,
  formName: propFormName,
  voucherType: propVoucherType,
}) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const dispatch = useDispatch();
  const location = useLocation();
  const permissions = useSelector(selectMenuPermissions);
  const GeneralSettings = useSelector(selectGeneralSettings);
  const activeFyid = useSelector(selectActiveFyid);
  const activeLocation = useSelector(selectActiveLocation);
  const { minDate, maxDate, validateAndAlert, isDateInFy } = useActiveFyLimits();
  const fyid = activeFyid || Number(sessionStorage.getItem("selectedFyId")) || Number(localStorage.getItem("selectedFyId")) || 0;

  useEffect(() => {
    if (dbCode) {
      dispatch(fetchActiveFinancialYear(dbCode));
    }
  }, [dbCode, dispatch]);
  const [roundOff, setRoundOff] = useState(3);
  const [amountDecimals, setAmountDecimals] = useState(2);

  const formatSmsAmount = (val) => {
    if (val === null || val === undefined || val === "") return "0.00";
    const num = parseFloat(String(val).replace(/,/g, ""));
    if (isNaN(num)) return "0.00";
    const dec = !isNaN(amountDecimals) && amountDecimals >= 0 ? amountDecimals : 2;
    return num.toFixed(dec);
  };

  const formatSmsWeight = (val) => {
    if (val === null || val === undefined || val === "") return "0.000";
    const num = parseFloat(String(val).replace(/,/g, ""));
    if (isNaN(num)) return "0.000";
    const dec = !isNaN(roundOff) && roundOff >= 0 ? roundOff : 3;
    return num.toFixed(dec);
  };
  const [companyName, setCompanyName] = useState("");
  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [selectedSlNo, setSelectedSlno] = useState(1);
  const [isPrintLoading, setIsPrintLoading] = useState(false);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        if (!dbCode) return;
        const response = await axios.get(
          `${apiBaseUrl}/main/findCompanyDetails/${dbCode}`
        );
        const foundData = response.data?.[0];
        if (foundData?.name) {
          setCompanyName(foundData.name);
        }
      } catch (error) {
        console.error("Error fetching company details:", error.message);
      }
    };
    fetchCompanyDetails();
  }, [apiBaseUrl, dbCode]);

  const [genValues, setGenValues] = useState({
    readonlyGrate: "",
    readonlyDate: "",
    sendwhatsappmsg: "",
  });

  const {
    fields: formFields,
    loading: formDesignerLoading,
    registerRef,
    handleKeyDown: handleDynamicKeyDown,
    focusField,
    getLabelStyle: getLabelStyleRaw,
    getInputStyle: getInputStyleRaw,
    getContainerStyle,
    isFieldVisible,
    isFieldDisabled,
    isFieldReadOnly,
    getFieldConfig,
    triggerInitialFocus,
    setFields: setFormFields,
    activeFieldId,
    rowBreakColumn,
    rowBreakTarget,
  } = useFormDesign();

  const getLabelStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getLabelStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    return filtered;
  };

  const getInputStyle = (fieldId, defaultStyles = {}) => {
    const fullStyle = getInputStyleRaw(fieldId, defaultStyles);
    const filtered = { ...defaultStyles };
    if (fullStyle.fontSize) filtered.fontSize = fullStyle.fontSize;
    if (fullStyle.fontWeight) filtered.fontWeight = fullStyle.fontWeight;
    if (fullStyle.fontStyle) filtered.fontStyle = fullStyle.fontStyle;
    if (fullStyle.fontFamily) filtered.fontFamily = fullStyle.fontFamily;
    return filtered;
  };

  useEffect(() => {
    const obj = GeneralSettings.find((item) => item.Name === "DECIMAL POINT");
    if (obj && obj.s_Value !== undefined && obj.s_Value !== "") {
      setRoundOff(parseInt(obj.s_Value, 10));
    }

    const objAmt = GeneralSettings.find((item) => item.Name === "DECIMAL POINT IN REPORT");
    if (objAmt && objAmt.s_Value !== undefined && objAmt.s_Value !== "") {
      setAmountDecimals(parseInt(objAmt.s_Value, 10));
    }

    const grate = GeneralSettings.find(
      (item) =>
        item.Name === "READ ONLY RATE FIELD FOR EMPLOYEES IN SCHEME RECEIPT",
    );

    if (grate) {
      setGenValues((prev) => ({
        ...prev,
        readonlyGrate: grate.ss_status,
      }));
    }

    const date = GeneralSettings.find(
      (item) =>
        item.Name === "READ ONLY DATE FIELD FOR EMPLOYEES IN SCHEME RECEIPT",
    );

    if (date) {
      setGenValues((prev) => ({
        ...prev,
        readonlyDate: date.ss_status,
      }));
    }

    const whatsapp = GeneralSettings.find(
      (item) => item.Name === "ENABLE WHATSAPP ON SCHEME RECEIPT",
    );

    if (whatsapp) {
      setGenValues((prev) => ({
        ...prev,
        sendwhatsappmsg: whatsapp.ss_status,
      }));
    }
  }, [GeneralSettings]);

  const { fId: stateFid, abbreviation: stateAbbr, typeOfVoucher: stateVType } = location.state || {};

  const getInitialFid = () => {
    return propFormId || stateFid || sessionStorage.getItem("selectedSchemeReceipt_fId") || "";
  };
  const getInitialAbbr = () => {
    return propFormName || stateAbbr || sessionStorage.getItem("selectedSchemeReceipt_abbreviation") || "";
  };
  const getInitialVType = () => {
    return propVoucherType || stateVType || sessionStorage.getItem("selectedSchemeReceipt_typeOfVoucher") || getInitialAbbr() || "SCHEME RECEIPT";
  };

  const [frmId, setfrmid] = useState(getInitialFid);
  const [fname, setfname] = useState(getInitialAbbr);
  const [vType, setVType] = useState(getInitialVType);

  useEffect(() => {
    const fid = propFormId || stateFid || sessionStorage.getItem("selectedSchemeReceipt_fId");
    const abbr = propFormName || stateAbbr || sessionStorage.getItem("selectedSchemeReceipt_abbreviation");
    const vt = propVoucherType || stateVType || sessionStorage.getItem("selectedSchemeReceipt_typeOfVoucher");
    if (fid) {
      setfrmid(fid);
      sessionStorage.setItem("selectedSchemeReceipt_fId", String(fid));
    }
    if (abbr) {
      setfname(abbr);
      sessionStorage.setItem("selectedSchemeReceipt_abbreviation", abbr);
    }
    if (vt) {
      setVType(vt);
      sessionStorage.setItem("selectedSchemeReceipt_typeOfVoucher", vt);
    }
  }, [propFormId, propFormName, propVoucherType, stateFid, stateAbbr, stateVType]);

  useEffect(() => {
    const fetchDefaultFormIfMissing = async () => {
      if (frmId) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/common/selectAllformDatas/${dbCode}`
        );
        const forms = response.data || [];
        const schemeForm = forms.find(
          (item) =>
            item.fmrTypeOfVoucher === "SCHEME RECEIPT" ||
            item.fmrTypeOfVoucher === "Scheme Receipt Order"
        );
        if (schemeForm) {
          setfrmid(schemeForm.fmrEntryNo);
          setfname(schemeForm.fmrAbbreviation || schemeForm.fmrName);
          setVType(schemeForm.fmrTypeOfVoucher);
          sessionStorage.setItem("selectedSchemeReceipt_fId", String(schemeForm.fmrEntryNo));
          sessionStorage.setItem("selectedSchemeReceipt_abbreviation", schemeForm.fmrAbbreviation || schemeForm.fmrName);
          sessionStorage.setItem("selectedSchemeReceipt_typeOfVoucher", schemeForm.fmrTypeOfVoucher);
        }
      } catch (err) {
        console.error("Error fetching default scheme form:", err.message);
      }
    };
    if (dbCode && !frmId) {
      fetchDefaultFormIfMissing();
    }
  }, [apiBaseUrl, dbCode, frmId]);

  const [userRights, setUserRights] = useState("");

  useEffect(() => {
    const storedRights = localStorage.getItem("uRights");
    if (storedRights) {
      try {
        const parsedRights = JSON.parse(storedRights);
        setUserRights(parsedRights);

        const formRights = parsedRights.find(
          (right) =>
            right.Fid === parseInt(frmId) && right.Type === "SCHEME RECEIPT",
        );

        setUserRights(formRights || null);
      } catch (error) {
        console.error("Error parsing user rights:", error);
        setUserRights([]);
      }
    }
  }, [frmId]);

  const { agentCode } = useContext(AuthContext);
  const agentCodeRef = useRef(agentCode);

  useEffect(() => {
    agentCodeRef.current = agentCode;
  }, [agentCode]);

  const [userType, setuserType] = useState("");
  const [dispTm, setdispTm] = useState("");

  useEffect(() => {
    const storeduType = sessionStorage.getItem("userType");
    if (storeduType) {
      setuserType(storeduType);
    }
  }, []);

  const [showFind, setShowFind] = useState(true);
  const [gridColumns, setGridColumns] = useState([]);

  useEffect(() => {
    const loadGridSettings = async () => {
      if (!dbCode || !vType) return;
      let cached = localStorage.getItem(`grid_design_${vType}`);
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          setGridColumns(parsed);
          return;
        } catch (e) {
          console.error("Error parsing cached settings:", e);
        }
      }

      try {
        const response = await axios.get(`${apiBaseUrl}/main/griddesign/${dbCode}/${vType}`);
        const dbCols = response.data.recordset || response.data || [];
        setGridColumns(dbCols);
      } catch (error) {
        console.error("Error loading grid settings:", error);
      }
    };
    loadGridSettings();
  }, [dbCode, apiBaseUrl, vType]);

  const isColumnVisible = (colName) => {
    if (gridColumns.length === 0) return true;
    const localMatch = gridColumns.find(
      (c) => c.columnName && String(c.columnName).toLowerCase() === colName.toLowerCase()
    );
    if (localMatch) {
      return localMatch.show;
    }
    const dbMatch = gridColumns.find(
      (c) => c.ColName && String(c.ColName).toLowerCase() === colName.toLowerCase()
    );
    if (dbMatch) {
      return dbMatch.Vis === 1;
    }
    return true;
  };
  const navigate = useNavigate();

  const cashaccinputRef = useRef(null);
  const schemIdinputRef = useRef(null);
  const rateInputRef = useRef(null);
  const dateInputRef = useRef(null);
  const saveButtonRef = useRef(null);
  const accnoRef = useRef(null);
  const agentRef = useRef(null);
  const accnameRef = useRef(null);
  const printButtonRef = useRef(null);
  const amountInputRef = useRef(null);
  const discInputRef = useRef(null);
  const totalInputRef = useRef(null);
  const gmInputRef = useRef(null);
  const discGmInputRef = useRef(null);
  const totalGmInputRef = useRef(null);
  const printgmRef = useRef(null);
  const narrationInputRef = useRef(null);
  const salesmanRef = useRef(null);
  const entryNoInputRef = useRef(null);

  const [editDisabled, setEditDisabled] = useState(true);
  const [deleteDisabled, setDeleteDisabled] = useState(true);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [printDisabled, setPrintDisabled] = useState(true);

  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    // Clamp to active FY limits
    if (minDate && formattedToday < minDate) return minDate;
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };

  const initialDateVal = getCurrentDate();

  const [tableData, setTableData] = useState([
    {
      SINo: "",
      name: "",
      agent: "",
      accountNumber: "",
      amount: "",
      disc: "",
      total: "",
      gm: "",
      discGm: "",
      totalGm: "",
      narration: "",
      printgm: "",
      billed: "",
      schemeId: "",
    },
  ]);

  const [locationOptions, setLocationOptions] = useState([]);

  const storedLocId = sessionStorage.getItem("loginLocationId") || localStorage.getItem("loginLocationId");
  const storedLocName = sessionStorage.getItem("loginLocation") || localStorage.getItem("loginLocation");

    const getDefaultBranch = () => {
    if (activeLocation?.id) return [Number(activeLocation.id), activeLocation.name];
    if (storedLocId) return [Number(storedLocId), storedLocName || "SHOP"];
    return [0, "SHOP"];
  };

  const getCleanLocationId = (locVal) => {
    if (Array.isArray(locVal)) {
      let inner = locVal[0];
      if (Array.isArray(inner)) inner = inner[0];
      const n = Number(inner);
      if (!isNaN(n) && n > 0) return n;
    } else if (locVal !== null && locVal !== undefined) {
      const n = Number(locVal);
      if (!isNaN(n) && n > 0) return n;
    }
    const fallback = Number(activeLocation?.id || storedLocId || 0);
    return fallback > 0 ? fallback : 1;
  };

  const resolveRecordLocation = (rawLoc) => {
    let locId = Array.isArray(rawLoc) ? rawLoc[0] : rawLoc;
    if (Array.isArray(locId)) locId = locId[0];
    const numId = Number(locId);
    if (!isNaN(numId) && numId > 0) {
      const found = locationOptions.find((item) => Number(item[0]) === numId);
      return found || [numId, "SHOP"];
    }
    return getDefaultBranch();
  };

  useEffect(() => {
    const fetchLocations = async () => {
      if (!dbCode) return;
      try {
        const response = await axios.get(
          `${apiBaseUrl}/otherregistration/getoptions/${dbCode}`
        );
        const data = response.data || [];
        const filtered = data
          .filter((item) => String(item.Type || item.type || "").toLowerCase() === "location")
          .map((item) => [Number(item.Auto ?? item.auto ?? 0), item.Name || item.name]);
        setLocationOptions(filtered);

        if (filtered.length > 0) {
          const targetId = activeLocation?.id || storedLocId;
          const match = targetId ? filtered.find((l) => Number(l[0]) === Number(targetId)) : null;
          const chosen = match || filtered[0];
          setschemeRecInfoData((prev) => {
            if (!prev.Location || !prev.Location[0] || prev.Location[0] === 0) {
              return { ...prev, Location: chosen };
            }
            return prev;
          });
        }
      } catch (error) {
        console.error("Error fetching location options:", error);
      }
    };
    fetchLocations();
  }, [apiBaseUrl, dbCode, activeLocation]);

  const [schemeRecInfoData, setschemeRecInfoData] = useState({
    EntryNo: "",
    cashAcc: "",
    schemeId: "",
    rate: "",
    date: initialDateVal,
    salesMan: "",
    totalamt: 0,
    totalDisc: 0,
    totalamtdisc: 0,
    totalgm: 0,
    totaldiscgm: 0,
    agCode: agentCode,
    Location: getDefaultBranch(),
  });

  const [schemeNames, setschemeNames] = useState([]);
  const [schemedatas, setschemedatas] = useState([]);
  const [filteredaccNo, setfilteredaccNo] = useState([]);
  // Stores scheme FromDate/ToDate keyed by SchemeId for date validation
  const [schemeDateMap, setSchemeDateMap] = useState({});

  const fetchSchemes = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/getSchemes/${dbCode}`,
      );

      if (response.data.success) {
        const formattedSchemes = response.data.data.map((item) => [
          item.SchemeId,
          item.SchemeName,
        ]);

        // Build a map of SchemeId -> { fromDate, toDate, validityType, schemeType } for validation
        const dateMap = {};
        response.data.data.forEach((item) => {
          dateMap[item.SchemeId] = {
            fromDate: item.FromDate ? item.FromDate.substring(0, 10) : null,
            toDate: item.ToDate ? item.ToDate.substring(0, 10) : null,
            validityType: item.ValidityType || "Fixed",
            schemeType: item.SchemeType || "Monthly",
          };
        });
        setSchemeDateMap(dateMap);
        setschemeNames(formattedSchemes);

        // Keep current selected scheme name synchronized if it was updated
        setschemeRecInfoData((prev) => {
          if (Array.isArray(prev.schemeId) && prev.schemeId.length > 0) {
            const currentId = prev.schemeId[0];
            const updated = response.data.data.find(
              (item) => item.SchemeId === currentId,
            );
            if (updated && updated.SchemeName !== prev.schemeId[1]) {
              return {
                ...prev,
                schemeId: [updated.SchemeId, updated.SchemeName],
              };
            }
          }
          return prev;
        });
      }
    } catch (error) {
      console.error("Error fetching schemes:", error);
    }
  };

  useEffect(() => {
    fetchSchemes();

    // WebSocket listener for real-time scheme updates
    const socket = io(apiBaseUrl);
    socket.on("SchemeUpdated", () => {
      fetchSchemes();
    });

    return () => {
      socket.disconnect();
    };
  }, [apiBaseUrl, dbCode]);

  const filterAccountNumbersByScheme = useCallback(
    (selectedScheme) => {
      if (
        !selectedScheme ||
        !Array.isArray(selectedScheme) ||
        selectedScheme.length === 0
      ) {
        setfilteredaccNo([]);
        return;
      }
      const schemeId = selectedScheme[0];
      const filteredData = schemedatas.filter(
        (item) => item.schemeId === schemeId && item.isActive === true,
      );
      const transformedData = filteredData.map((item) => [
        item.auto,
        item.accno,
      ]);
      setfilteredaccNo(transformedData);
    },
    [schemedatas],
  );

  const handleSchemeChange = (newScheme) => {
    const newSchemeId = Array.isArray(newScheme) ? newScheme[0] : null;
    const currentSchemeId = Array.isArray(schemeRecInfoData.schemeId)
      ? schemeRecInfoData.schemeId[0]
      : null;

    const hasData = tableData.some(
      (row) =>
        (row.accountNumber && (Array.isArray(row.accountNumber) ? row.accountNumber[1] : row.accountNumber)) ||
        (row.name && (Array.isArray(row.name) ? row.name[1] : row.name)) ||
        (row.amount && row.amount !== "")
    );

    if (hasData && newSchemeId && currentSchemeId && newSchemeId !== currentSchemeId) {
      const confirmClear = window.confirm(
        "Changing Scheme will clear the customer entries entered in the table.\nDo you want to proceed?"
      );
      if (!confirmClear) {
        return;
      }
      setTableData([
        {
          SINo: "",
          name: "",
          agent: "",
          accountNumber: "",
          amount: "",
          disc: "",
          total: "",
          gm: "",
          discGm: "",
          totalGm: "",
          narration: "",
          printgm: "",
          billed: "",
          schemeId: "",
        },
      ]);
    }

    setschemeRecInfoData((prev) => ({ ...prev, schemeId: newScheme }));
    filterAccountNumbersByScheme(newScheme);
  };

  const handleCellChange = useCallback((event, rowIndex, field) => {
    setTableData((prevData) => {
      const newData = [...prevData];
      newData[rowIndex] = { ...newData[rowIndex], [field]: event };
      return newData;
    });
  }, []);

  const handleCellChangeinput = useCallback((event, rowIndex, field) => {
    setTableData((prevData) => {
      const newData = [...prevData];
      if (field === "printgm") {
        newData[rowIndex] = {
          ...newData[rowIndex],
          [field]: event.target.checked ? 1 : 0,
        };
      } else {
        newData[rowIndex] = {
          ...newData[rowIndex],
          [field]: event.target.value,
        };
      }
      return newData;
    });
  }, []);

  const calculateGmvalue = useCallback(
    (amount, index, field = "gm") => {
      if (!schemeRecInfoData.rate || schemeRecInfoData.rate === 0) {
        handleCellChange("", index, field);
        return;
      }

      if (amount && amount !== "") {
        const Rate = parseFloat(schemeRecInfoData.rate);
        const calcgm = (parseFloat(amount) / Rate).toFixed(roundOff);
        handleCellChange(calcgm, index, field);
      } else {
        handleCellChange("", index, field);
      }
    },
    [schemeRecInfoData.rate, roundOff, handleCellChange],
  );

  const calculateRowTotalAndGms = useCallback(
    (index, currentTableData = tableData) => {
      const row = currentTableData[index] || {};
      const amt = parseFloat(row.amount || 0);
      const disc = parseFloat(row.disc || 0);
      const tot = amt + disc;
      
      const rate = parseFloat(schemeRecInfoData.rate || 0);
      let gmVal = "";
      let discGmVal = "";
      let totalGmVal = "";

      if (rate !== 0) {
        if (row.amount !== "" && row.amount !== null && row.amount !== undefined) {
          gmVal = (amt / rate).toFixed(roundOff);
        }
        if (row.disc !== "" && row.disc !== null && row.disc !== undefined) {
          discGmVal = (disc / rate).toFixed(roundOff);
        }
        if (tot > 0 || (row.amount !== "" || row.disc !== "")) {
          totalGmVal = (tot / rate).toFixed(roundOff);
        }
      }

      setTableData((prevData) => {
        const newData = [...prevData];
        newData[index] = {
          ...newData[index],
          total: tot > 0 || row.amount !== "" || row.disc !== "" ? tot : "",
          gm: gmVal,
          discGm: discGmVal,
          totalGm: totalGmVal,
        };
        return newData;
      });
    },
    [schemeRecInfoData.rate, roundOff, tableData],
  );

  // Initial focus is handled dynamically by FormDesign Context Provider

  const fetchSchEntryno = useCallback(async () => {
    const activeFid = parseInt(frmId);
    if (!activeFid || isNaN(activeFid)) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_entryno/${activeFid}/${dbCode}/${fyid}`,
      );
      const schemeRecentryNo = response.data?.map((item) => item[""]);
      if (schemeRecentryNo && schemeRecentryNo[0] !== undefined) {
        setschemeRecInfoData((prevData) => ({
          ...prevData,
          EntryNo: schemeRecentryNo[0],
        }));
      }
    } catch (error) {
      console.error("Error fetching entry no:", error.message);
    }
  }, [apiBaseUrl, frmId, dbCode, fyid]);

  useEffect(() => {
    fetchSchEntryno();
  }, [fetchSchEntryno]);

  useEffect(() => {
    const socket = io(apiBaseUrl);
    socket.on("tableUpdated", () => {
      fetchSchEntryno();
    });
    socket.on("printTemplateUpdated", () => {
      clearPrintTemplateCache();
    });

    const handleLocalPrintSync = () => {
      clearPrintTemplateCache();
    };
    window.addEventListener("printTemplateUpdated", handleLocalPrintSync);

    return () => {
      socket.disconnect();
      window.removeEventListener("printTemplateUpdated", handleLocalPrintSync);
    };
  }, [apiBaseUrl, fetchSchEntryno]);

  const [cnameData, setCnameData] = useState([]);

  useEffect(() => {
    const fetchCname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_Cname/${dbCode}`,
        );
        const cName = response.data;
        const transformedData = cName.map((item) => [
          item.Ledcode,
          item.LedName,
        ]);
        setCnameData(transformedData);
      } catch (error) {
        console.error("Error fetching cashorsuppl Values:", error.message);
      }
    };

    fetchCname();
  }, [apiBaseUrl, dbCode]);

  const [agentName, setagentName] = useState([]);

  useEffect(() => {
    const fetchAgname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/schsalesmanNames/${dbCode}`,
        );
        const AgName = response.data;
        const transformedData = AgName.map((item) => [item.Auto, item.Name]);
        setagentName(transformedData);
      } catch (error) {
        console.error("Error fetching agent Values:", error.message);
      }
    };

    fetchAgname();
  }, [apiBaseUrl, dbCode]);

  const [accNo, setaccNo] = useState([]);
  const storeduType = sessionStorage.getItem("userType");

  useEffect(() => {
    const fetchAccno = async () => {
      try {
        const agentWiseSetting = GeneralSettings.find(
          (item) => item.Name === "AGENT WISE ACCOUNT NUMBER IN SCHEME RECEIPT",
        );
        const useAgentWise =
          agentWiseSetting && agentWiseSetting.ss_status === 1;

        let url;
        if (useAgentWise && storeduType !== "ADMIN") {
          url = `${apiBaseUrl}/main/SchRec_AccnobyAgent/${parseInt(
            agentCode,
          )}/${dbCode}`;
        } else {
          url = `${apiBaseUrl}/main/SchRec_Accno/${dbCode}`;
        }

        const response = await axios.get(url);
        setschemedatas(response.data);

        console.log("Fetched accno data:", response.data);

        const transformedData = response.data.map((item) => [
          item.auto,
          item.accno,
        ]);
        setaccNo(transformedData);
      } catch (error) {
        console.error("Error fetching accno Values:", error.message);
      }
    };

    fetchAccno();
  }, [apiBaseUrl, storeduType, agentCode, GeneralSettings, dbCode]);

  const [selectcashAcc, setselectcashAcc] = useState([]);

  useEffect(() => {
    const selectcashAcc = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_caba/${dbCode}`,
        );
        const caba = response.data;
        const transformedData = caba.map((item) => [
          item.ledcode,
          item.LedName,
        ]);
        setselectcashAcc(transformedData);

        const effectiveAg = agentCode || sessionStorage.getItem("agentCode") || localStorage.getItem("agentCode");
        const effectiveUType = userType || storeduType || sessionStorage.getItem("userType") || localStorage.getItem("userType") || "";
        if (effectiveUType !== "CUSTOMERS" && effectiveAg) {
          fetchcashAcc(transformedData, effectiveAg);
        }
      } catch (error) {
        console.error("Error fetching selectcashAcc Values:", error.message);
      }
    };
    selectcashAcc();
  }, [apiBaseUrl, userType, dbCode, agentCode]);

  const Selectcashacc = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRec_caba/${dbCode}`,
      );
      const caba = response.data;
      const transformedData = caba.map((item) => [item.ledcode, item.LedName]);
      setselectcashAcc(transformedData);

      const effectiveAg = agentCode || sessionStorage.getItem("agentCode") || localStorage.getItem("agentCode");
      const effectiveUType = userType || storeduType || sessionStorage.getItem("userType") || localStorage.getItem("userType") || "";
      if (effectiveUType !== "CUSTOMERS" && effectiveAg) {
        fetchcashAcc(transformedData, effectiveAg);
      }
    } catch (error) {
      console.error("Error fetching selectcashAcc Values:", error.message);
    }
  };

  const fetchcashAcc = async (data = selectcashAcc, targetAgentCode = null) => {
    const rawAgent = targetAgentCode || agentCode || sessionStorage.getItem("agentCode") || localStorage.getItem("agentCode");
    const activeAgCode = parseInt(rawAgent, 10);
    if (!activeAgCode || isNaN(activeAgCode) || !dbCode) {
      return;
    }
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/fetchcashacc/${activeAgCode}/${dbCode}`,
      );
      const caba = response.data?.[0];
      if (caba && caba.cashAcc) {
        const targetAccId = parseInt(caba.cashAcc, 10);
        const accList = (data && data.length > 0) ? data : selectcashAcc;
        const matchedAcc = accList.find((item) => parseInt(item[0], 10) === targetAccId);
        if (matchedAcc) {
          setschemeRecInfoData((prevState) => ({
            ...prevState,
            cashAcc: matchedAcc,
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching Accno data:", error.message);
    }
  };

  useEffect(() => {
    const effectiveAg = agentCode || sessionStorage.getItem("agentCode") || localStorage.getItem("agentCode");
    const effectiveUType = userType || storeduType || sessionStorage.getItem("userType") || localStorage.getItem("userType") || "";
    if (effectiveUType !== "CUSTOMERS" && effectiveAg && selectcashAcc.length > 0) {
      if (!schemeRecInfoData.cashAcc || (Array.isArray(schemeRecInfoData.cashAcc) && !schemeRecInfoData.cashAcc[0])) {
        fetchcashAcc(selectcashAcc, effectiveAg);
      }
    }
  }, [agentCode, selectcashAcc, dbCode]);

  const fetchSchCurrentRate = async (targetDate) => {
    try {
      const dateToUse = targetDate || schemeRecInfoData.date;
      const response = await axios.get(
        `${apiBaseUrl}/main/getGoldRate/${dbCode}?date=${dateToUse || ""}`,
      );
      const currentrate = response.data[0]?.currentRate;
      setschemeRecInfoData((prevData) => ({
        ...prevData,
        rate: userRights && userRights.GR === 1 ? (currentrate || 0) : 0,
      }));
    } catch (error) {
      console.error("Error fetching gold rate:", error.message);
    }
  };

  useEffect(() => {
    fetchSchCurrentRate(schemeRecInfoData.date);
  }, [apiBaseUrl, userRights, dbCode, schemeRecInfoData.date]);

  useEffect(() => {
    let totalAmount = 0;
    let totalDisc = 0;
    let totalAmtDisc = 0;
    let totalGm = 0;
    let totalDiscGm = 0;
    tableData.forEach((rowData) => {
      totalAmount += parseFloat(rowData.amount || 0);
      totalDisc += parseFloat(rowData.disc || 0);
      totalAmtDisc += parseFloat(rowData.total || 0);
      totalGm += parseFloat(rowData.gm || 0);
      totalDiscGm += parseFloat(rowData.discGm || 0);
    });
    setschemeRecInfoData((prevState) => ({
      ...prevState,
      totalamt: totalAmount.toFixed(roundOff),
      totalDisc: totalDisc.toFixed(roundOff),
      totalamtdisc: totalAmtDisc.toFixed(roundOff),
      totalgm: totalGm.toFixed(roundOff),
      totaldiscgm: totalDiscGm.toFixed(roundOff),
    }));
  }, [tableData, roundOff]);

  const handleClear = () => {
    fetchSchEntryno();
    fetchSchCurrentRate();
    Selectcashacc();
    setdispWt("");
    setdispTm("");
    setschemeRecInfoData({
      EntryNo: schemeRecInfoData.EntryNo,
      cashAcc: "",
      schemeId: "",
      salesMan: "",
      date: getCurrentDate(),
      totalamt: "",
      totalDisc: "",
      totalamtdisc: "",
      totalgm: "",
      totaldiscgm: "",
      rate: "",
      agCode: agentCode,
      Location: getDefaultBranch(),
    });

    setTableData([
      {
        SINo: "",
        name: "",
        agent: "",
        accountNumber: "",
        amount: "",
        disc: "",
        total: "",
        gm: "",
        discGm: "",
        totalGm: "",
        narration: "",
        printgm: "",
        billed: "",
        schemeId: "",
      },
    ]);

    triggerInitialFocus();
    setEditDisabled(true);
    setDeleteDisabled(true);
    setSaveDisabled(false);
    setShowFind(true);
    setPrintDisabled(true);
  };

  // FIXED: Account Number fetch with proper state update
  const fetchAccNoData = useCallback(
    async (selectedAccountNumber, rowIndex) => {
      if (!selectedAccountNumber || !selectedAccountNumber[1]) {
        return;
      }

      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/findbyaccnotable/${dbCode}`,
          { params: { accNo: selectedAccountNumber[1] } }
        );
        const fetchedData = response.data;

        if (Array.isArray(fetchedData) && fetchedData.length > 0) {
          const { accname, agent } = fetchedData[0];
          const matchingCnameData = cnameData.find(
            (item) => item[0] === accname,
          );
          const matchingAgentData = agentName.find(
            (item) => item[0] === parseInt(agentCode),
          );
          const matchingSchemeData = schemedatas.find(
            (item) => String(item.accno) === String(selectedAccountNumber[1]),
          );

          setTableData((prevData) => {
            const newData = [...prevData];
            newData[rowIndex] = {
              ...newData[rowIndex],
              name: matchingCnameData || [],
              agent: matchingAgentData || [],
              accountNumber: selectedAccountNumber,
              schemeId:
                matchingSchemeData?.schemeId || schemeRecInfoData.schemeId?.[0],
            };
            return newData;
          });

          dispTotalWt(rowIndex, accname);
          printTotalBalance(rowIndex, accname);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    },
    [
      apiBaseUrl,
      dbCode,
      cnameData,
      agentName,
      agentCode,
      schemedatas,
      schemeRecInfoData.schemeId,
    ],
  );

  const fetchAccNmData = useCallback(
    async (selectedName, rowIndex) => {
      if (
        !selectedName ||
        !Array.isArray(selectedName) ||
        selectedName.length === 0
      ) {
        return;
      }

      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/findbyaccnametable/${selectedName[0]}/${dbCode}`,
        );
        const fetchedData = response.data;

        if (Array.isArray(fetchedData) && fetchedData.length > 0) {
          const { accno, agent } = fetchedData[0];
          const matchingAccnoData = accNo.find((item) => item[1] === accno);
          const matchingAgentData = agentName.find(
            (item) => item[0] === parseInt(agentCode),
          );
          const matchingSchemeData = schemedatas.find(
            (item) => item.accno === accno,
          );

          setTableData((prevData) => {
            const newData = [...prevData];
            newData[rowIndex] = {
              ...newData[rowIndex],
              accountNumber: matchingAccnoData || [],
              agent: matchingAgentData || [],
              name: selectedName,
              schemeId:
                matchingSchemeData?.schemeId || schemeRecInfoData.schemeId?.[0],
            };
            return newData;
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    },
    [
      apiBaseUrl,
      dbCode,
      accNo,
      agentName,
      agentCode,
      schemedatas,
      schemeRecInfoData.schemeId,
    ],
  );

  const [showFindDialog, setShowFindDialog] = useState(false);
  const [findEntryNo, setFindEntryNo] = useState("");

  const openFindDialog = () => {
    setShowFindDialog(true);
  };

  const closeFindDialog = () => {
    setShowFindDialog(false);
    setFindEntryNo("");
  };

  const handleFindbyentrynumber = async () => {
    handleClear();
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/SchRecfindbyentryNo/${findEntryNo}/${parseInt(
          frmId,
        )}/${dbCode}/${fyid}`,
      );

      if (response.status === 200 && response.data.length > 0) {
        const foundData = response.data;
        const newData = foundData.map((row) => ({
          name: cnameData.find((item) => item[0] === row.Srp_name),
          agent: agentName.find((item) => item[0] === row.Srp_agent),
          accountNumber: accNo.find((item) => item[0] === row.Srp_accountno),
          amount: row.Srp_amount,
          disc: row.Srp_discount || "",
          total: row.Srp_total || row.Srp_amount,
          gm: row.Srp_gm,
          discGm: row.Srp_discGm || "",
          totalGm: row.Srp_gm ? (parseFloat(row.Srp_gm) + parseFloat(row.Srp_discGm || 0)).toFixed(roundOff) : "",
          narration: row.Srp_narration,
          printgm: row.Srp_printgm,
          billed: row.Srp_Billed,
          schemeId: row.Srp_SchemeId,
        }));

        const firstRowData = foundData[0];
        setschemeRecInfoData({
          ...schemeRecInfoData,
          EntryNo: firstRowData.SrInfo_entryno,
          cashAcc: selectcashAcc.find(
            (item) => item[0] === firstRowData.SrInfo_cashaccount,
          ),
          schemeId: schemeNames.find(
            (item) => item[0] === firstRowData.SrInfo_SchemeId,
          ),
          rate: firstRowData.SrInfo_rate,
          date: formatDate(firstRowData.SrInfo_date),
          salesMan: agentName.find(
            (item) => item[0] === firstRowData.SrInfosalesMan,
          ),
          totalamt: firstRowData.SrInfo_totalamount,
          totalDisc: firstRowData.SrInfo_totalDisc || 0,
          totalamtdisc: firstRowData.SrInfo_totalamtdisc || firstRowData.SrInfo_totalamount,
          totalgm: firstRowData.SrInfo_totalgm,
          totaldiscgm: firstRowData.SrInfo_totaldiscgm || 0,
          Location: resolveRecordLocation(firstRowData.Location),
        });

        setTableData(newData);
        if (newData.length > 0 && newData[0].name) {
          const firstCust = Array.isArray(newData[0].name) ? newData[0].name[0] : (newData[0].name?.value ?? newData[0].name);
          dispTotalWt(0, firstCust);
          printTotalBalance(0, firstCust);
        }
        setEditDisabled(false);
        setDeleteDisabled(false);
        setSaveDisabled(true);
        setShowFind(false);
        triggerInitialFocus();
      } else {
        alert("Entry not found!");
      }
    } catch (error) {
      console.error("Error:", error.message);
      alert("Error finding entry!");
    }
    closeFindDialog();
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleDelete = async () => {
    if (!window.confirm("Do You Want To Delete..?")) {
      return;
    }

    try {
      const response = await axios.delete(
        `${apiBaseUrl}/main/deleterecbyentryno/${
          schemeRecInfoData.EntryNo
        }/${parseInt(frmId)}/${dbCode}/${fyid}?location=${getCleanLocationId(schemeRecInfoData.Location)}`,
      );
      if (response.status === 200) {
        alert("Entry Deleted Successfully!");
        handleClear();
        setShowFind(true);
      } else {
        console.error("Error deleting data:", response.data);
        alert("Failed to delete!");
      }
    } catch (error) {
      console.error("Error:", error.message);
      alert("Error deleting entry!");
    }
  };

  const [isAutoPrintAfterSave, setIsAutoPrintAfterSave] = useState(false);
  const [printSnapshot, setPrintSnapshot] = useState(null);

  const openPrintDialog = (isFromSave = false) => {
    setSelectedSlno(1);
    setIsAutoPrintAfterSave(isFromSave);
    setShowPrintDialog(true);
  };

  const closePrintDialog = () => {
    setShowPrintDialog(false);
    if (isAutoPrintAfterSave) {
      setIsAutoPrintAfterSave(false);
      setPrintSnapshot(null);
      handleClear();
    }
  };

  const handlePrint = () => {
    openPrintDialog(false);
  };

  const handleCheckSlno = () => {
    const dataSource =
      tableData && tableData.some((row) => Object.values(row).some((val) => val !== ""))
        ? tableData
        : printSnapshot?.tableData || [];
    const filteredTableData = dataSource.filter((row) => {
      return Object.values(row).some((value) => value !== "");
    });
    return filteredTableData.length;
  };

  const _toWords = new ToWords({ localeCode: "en-IN" });

  const formatPrintDate = (dateStr) => {
    try {
      const d = new Date(dateStr);
      const options = { day: "2-digit", month: "short", year: "numeric" };
      return new Intl.DateTimeFormat("en-GB", options).format(d).replace(/ /g, "/");
    } catch (_) { return dateStr || ""; }
  };

  const buildPrintData = (rowIndex, extraData = {}) => {
    const dataSource =
      tableData && tableData.some((row) => Object.values(row).some((val) => val !== ""))
        ? tableData
        : printSnapshot?.tableData || [];
    const infoSource =
      tableData && tableData.some((row) => Object.values(row).some((val) => val !== ""))
        ? schemeRecInfoData
        : printSnapshot?.schemeRecInfoData || schemeRecInfoData;

    const row = dataSource[rowIndex] || {};
    const totalAmt = parseFloat(row.total || row.amount || 0);
    const amtStr = totalAmt > 0 ? String(totalAmt) : "";
    let amtWords = "";
    try { amtWords = totalAmt > 0 ? _toWords.convert(totalAmt) : ""; } catch (_) {}

    const currentWeight = parseFloat(row.totalGm || row.gm || 0);
    const oldWt = extraData.oldWeight !== undefined ? extraData.oldWeight : (parseFloat(dispWt || 0) || "");
    const totWt = extraData.totalWeight !== undefined ? extraData.totalWeight : (
      (parseFloat(oldWt || 0) + currentWeight) > 0 
        ? (parseFloat(oldWt || 0) + currentWeight).toFixed(3) 
        : (dispWt || printSnapshot?.dispWt || infoSource.totalgm || currentWeight || "")
    );
    const oldBal = extraData.oldBalance !== undefined ? extraData.oldBalance : (dispTm || printSnapshot?.dispTm || "");
    const closeBal = extraData.closingBalance !== undefined ? extraData.closingBalance : (
      (parseFloat(oldBal || 0) + totalAmt).toFixed(2)
    );

    return {
      VoucherNo:      `${infoSource.EntryNo || ""} -${(Array.isArray(row.agent) ? row.agent[1] : row.agent || "").substring(0, 3)}`,
      Date:           formatPrintDate(infoSource.date),
      AccountNo:      Array.isArray(row.accountNumber) ? (row.accountNumber[1] || "") : (row.accountNumber || ""),
      CustomerName:   Array.isArray(row.name) ? (row.name[1] || "") : (row.name || ""),
      TotalAmount:    amtStr,
      AmountInWords:  amtWords,
      PaymentMode:    "CASH",
      Rate:           String(infoSource.rate || ""),
      OldWeight:      oldWt !== "" ? String(oldWt) : "",
      Weight:         currentWeight > 0 ? String(currentWeight) : String(row.totalGm || row.gm || ""),
      TotalWeight:    String(totWt || ""),
      SchemeName:     Array.isArray(infoSource.schemeId) ? (infoSource.schemeId[1] || "") : (infoSource.schemeId || ""),
      CashAccount:    Array.isArray(infoSource.cashAcc) ? (infoSource.cashAcc[1] || "") : (infoSource.cashAcc || ""),
      AgentName:      Array.isArray(row.agent) ? (row.agent[1] || "") : (row.agent || ""),
      SalesMan:       Array.isArray(infoSource.salesMan) ? (infoSource.salesMan[1] || "") : (infoSource.salesMan || ""),
      OldBalance:     oldBal !== "" ? String(oldBal) : "",
      ClosingBalance: String(closeBal),
      TotalPaidAmount: String(closeBal),
      CompanyName:    companyName || "",
    };
  };

  const handleDynamicAction = async (action) => {
    const slno = parseInt(selectedSlNo);
    const slnoLimit = handleCheckSlno();
    if (!slno || slno > slnoLimit || slno <= 0) {
      Swal.fire({ icon: "warning", title: "Invalid Sl No", text: "Please enter a valid Sl No to print.", timer: 2000, showConfirmButton: false });
      return;
    }

    const rowIndex = slno - 1;
    const dataSource =
      tableData && tableData.some((row) => Object.values(row).some((val) => val !== ""))
        ? tableData
        : printSnapshot?.tableData || [];
    const infoSource =
      tableData && tableData.some((row) => Object.values(row).some((val) => val !== ""))
        ? schemeRecInfoData
        : printSnapshot?.schemeRecInfoData || schemeRecInfoData;
    const row = dataSource[rowIndex] || {};
    const ledCode = Array.isArray(row.name) ? row.name[0] : (row.name?.value ?? row.name?.Ledcode ?? row.name);
    const currentWeight = parseFloat(row.totalGm || row.gm || 0);
    const currentAmount = parseFloat(row.total || row.amount || 0);
    const currentEntryNo = infoSource.EntryNo;
    const currentFrmId = frmId;

    let extraData = {};
    if (ledCode) {
      try {
        const res = await axios.get(
          `${apiBaseUrl}/main/recbalances/${ledCode}/${dbCode}?entryNo=${currentEntryNo}&frmId=${currentFrmId}`
        );
        if (res.data && res.data[0]) {
          const b = res.data[0];
          const isSaved = b.isSaved === 1 || b.isSaved === true;
          if (isSaved) {
            extraData = {
              oldWeight: parseFloat(b.oldWeight || 0).toFixed(3),
              totalWeight: parseFloat(b.totalWeight || 0).toFixed(3),
              oldBalance: parseFloat(b.oldBalance || 0).toFixed(2),
              closingBalance: parseFloat(b.totalBalance || 0).toFixed(2),
            };
          } else {
            const calculatedTotalWt = (parseFloat(b.oldWeight || 0) + currentWeight).toFixed(3);
            const calculatedTotalBal = (parseFloat(b.oldBalance || 0) + currentAmount).toFixed(2);
            extraData = {
              oldWeight: parseFloat(b.oldWeight || 0).toFixed(3),
              totalWeight: calculatedTotalWt,
              oldBalance: parseFloat(b.oldBalance || 0).toFixed(2),
              closingBalance: calculatedTotalBal,
            };
          }
        }
      } catch (err) {
        console.warn("Could not fetch customer balances for print:", err);
      }
    }

    const data = buildPrintData(rowIndex, extraData);
    const safeVoucherNo = (data.VoucherNo || String(slno)).replace(/[^a-zA-Z0-9_-]/g, "_");
    const safeDate = (data.Date || "").replace(/\//g, "-");
    const fileName = `SchemeReceipt_${safeVoucherNo}_${safeDate}.pdf`;

    const voucherKey = action === "download" ? "SCHEME RECEIPT PDF" : "SCHEME RECEIPT";

    setIsPrintLoading(true);
    try {
      await printWithTemplate(voucherKey, data, apiBaseUrl, dbCode, {
        action,
        location: activeLocation?.id || 0,
        fileName,
      });
      if (action !== "blob") closePrintDialog();
    } catch (err) {
      if (action === "download" && err?.message?.includes("No print template assigned")) {
        try {
          await printWithTemplate("SCHEME RECEIPT", data, apiBaseUrl, dbCode, {
            action,
            location: activeLocation?.id || 0,
            fileName,
          });
          closePrintDialog();
          return;
        } catch (_) {}
      }
      console.warn("Print template encountered an issue:", err);
      Swal.fire({
        icon: "error",
        title: "Print Failed",
        text: err?.message || "Failed to generate print.",
      });
    } finally {
      setIsPrintLoading(false);
    }
  };

  const [dispWt, setdispWt] = useState("");

  const dispTotalWt = async (index, e) => {
    try {
      const led = Array.isArray(e) ? e[0] : (e?.value ?? e?.Ledcode ?? e);
      if (!led) return;
      const response = await axios.get(
        `${apiBaseUrl}/main/totalweight/${led}/${dbCode}`,
      );
      setdispWt(response.data[0]?.WeightDifference || 0);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const printTotalBalance = async (index, e) => {
    try {
      const led = Array.isArray(e) ? e[0] : (e?.value ?? e?.Ledcode ?? e);
      if (!led) return;
      const response = await axios.get(
        `${apiBaseUrl}/main/recprintob/${led}/${dbCode}`,
      );
      setdispTm(parseFloat(response.data[0]?.oldBalance || 0));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const checkNameExists = (e) => {
    if (e.key === "Enter" || e.key === "Return") {
      if (!cnameData.find((item) => item[1] === e.target.value)) {
        alert("Account not registered");
      }
    }
  };

  const checkAccnoExists = (e) => {
    if (e.key === "Enter" || e.key === "Return") {
      if (!accNo.find((item) => item[1] === e.target.value)) {
        alert("Account number not registered");
      }
    }
  };

  ////////////////////////// SMS & WhatsApp Functions //////////////////////////
  const fetchsmssettings = async (eName) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectapidatas/${dbCode}/${eName}?locationId=${activeLocation ? activeLocation.id : ""}`,
      );
      const smsData = response.data[0];
      return smsData;
    } catch (error) {
      console.error("Error fetching smssettings Values:", error.message);
    }
  };

  const fetchwhatsappsettings = async (eName) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectwhtAppapidatas/${dbCode}/${eName}?locationId=${activeLocation ? activeLocation.id : ""}`,
      );
      const whtsappData = response.data[0];
      return whtsappData;
    } catch (error) {
      console.error("Error fetching whtsappData Values:", error.message);
    }
  };

  const sendWhatsAppMessage = async (
    accountNo,
    mobileNo,
    customerName,
    total,
    grandTotal,
    netwt,
    gm,
  ) => {
    try {
      if (genValues?.sendwhatsappmsg !== 1) {
        return { success: false, message: "WhatsApp messaging disabled" };
      }

      const whatsappData = await fetchwhatsappsettings("SCHEME RECEIPT");
      if (!whatsappData) {
        console.error("WhatsApp settings not found");
        return { success: false, message: "WhatsApp settings not found" };
      }

      const formattedTotal = formatSmsAmount(total);
      const formattedGrandTotal = formatSmsAmount(grandTotal);
      const formattedNetwt = formatSmsWeight(netwt);
      const formattedGm = formatSmsWeight(gm);
      const formattedRate = formatSmsAmount(schemeRecInfoData.rate);
      const showroomName = (Array.isArray(schemeRecInfoData.Location) ? schemeRecInfoData.Location[1] : schemeRecInfoData.Location) || sessionStorage.getItem("loginLocation") || "";

      let message = whatsappData.MessageBody || "";

      const replacements = {
        "${accountNo}": accountNo ?? "",
        "${customerName}": customerName ?? "",
        "${total}": formattedTotal,
        "${grandTotal}": formattedGrandTotal,
        "${netwt}": formattedNetwt,
        "${gm}": formattedGm,
        "${rate}": formattedRate,
        "${showroomName}": showroomName,
        "${date}": schemeRecInfoData.date || new Date().toLocaleDateString(),
        "${entryNo}": schemeRecInfoData.EntryNo || "",
      };

      Object.keys(replacements).forEach((key) => {
        message = message.split(key).join(replacements[key]);
      });

      const messageData = new FormData();
      messageData.append("appkey", whatsappData.appKey || "");
      messageData.append("authkey", whatsappData.Authkey || "");
      messageData.append("to", `91${mobileNo}`);
      messageData.append("message", message);

      if (whatsappData.MediaUrl) {
        messageData.append("file", whatsappData.MediaUrl);
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000);

      const response = await axios.post(
        "https://wabulksenderpro.net/api/create-message",
        messageData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          signal: controller.signal,
        },
      );

      clearTimeout(timeoutId);

      return {
        success: true,
        data: response.data,
        message: `Message sent to ${mobileNo}`,
      };
    } catch (error) {
      console.error(`Error sending WhatsApp message to ${mobileNo}:`, {
        message: error.message,
        code: error.code,
        response: error.response?.data,
        status: error.response?.status,
        isAxiosError: axios.isAxiosError(error),
        isTimeout: error.code === "ECONNABORTED" || error.name === "AbortError",
      });

      return {
        success: false,
        error: error.message,
        mobileNo: mobileNo,
      };
    }
  };

  const sendSMS = async (
    accountNo,
    mobileNo,
    customerName,
    total,
    grandTotal,
    netwt,
    gm,
  ) => {
    if (userRights?.SRSMS !== 1) {
      return;
    }

    const apiData = await fetchsmssettings("SCHEME RECEIPT");
    if (!apiData || !apiData.MessageBody || !apiData.ApiLink) {
      console.warn("SMS settings not found or incomplete for SCHEME RECEIPT");
      return null;
    }

    const formattedTotal = formatSmsAmount(total);
    const formattedGrandTotal = formatSmsAmount(grandTotal);
    const formattedNetwt = formatSmsWeight(netwt);
    const formattedGm = formatSmsWeight(gm);
    const formattedRate = formatSmsAmount(schemeRecInfoData.rate);
    const showroomName = (Array.isArray(schemeRecInfoData.Location) ? schemeRecInfoData.Location[1] : schemeRecInfoData.Location) || sessionStorage.getItem("loginLocation") || "";

    let message = apiData.MessageBody || "";

    const replacements = {
      "${accountNo}": accountNo ?? "",
      "${customerName}": customerName ?? "",
      "${total}": formattedTotal,
      "${grandTotal}": formattedGrandTotal,
      "${netwt}": formattedNetwt,
      "${gm}": formattedGm,
      "${rate}": formattedRate,
      "${showroomName}": showroomName,
      "${date}": schemeRecInfoData.date || new Date().toLocaleDateString(),
      "${entryNo}": schemeRecInfoData.EntryNo || "",
    };

    Object.keys(replacements).forEach((key) => {
      message = message.split(key).join(replacements[key]);
    });

    const url = apiData.ApiLink
      .split("${mobileNo}").join(mobileNo)
      .split("${encodeURIComponent(message)}").join(encodeURIComponent(message))
      .split("${message}").join(encodeURIComponent(message));

    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error sending SMS to ${mobileNo}:`, error.message);
      return null;
    }
  };

  const checkledgerExists = (e) => {
    if (e.key === "Enter" || e.key === "Return") {
      if (!selectcashAcc.find((item) => item[1] === e.target.value)) {
        alert("Account does not Exist");
      }
    }
  };

  const handleSave = async () => {
    setSaveDisabled(true);

    try {
      if (schemeRecInfoData.date && !isDateInFy(schemeRecInfoData.date)) {
        alert("Date incompatible with financial year");
        setSaveDisabled(false);
        return;
      }
      if (
        !schemeRecInfoData.schemeId ||
        !Array.isArray(schemeRecInfoData.schemeId) ||
        schemeRecInfoData.schemeId.length === 0
      ) {
        alert("Please select a Scheme Name first before entering data.");
        setSaveDisabled(false);
        return;
      }

      // ── Scheme date range validation ──
      const selectedSchemeId = schemeRecInfoData.schemeId?.[0];
      const schemeInfo = schemeDateMap[selectedSchemeId];
      if (schemeInfo) {
        const receiptDate = schemeRecInfoData.date; // "YYYY-MM-DD"
        if (schemeInfo.validityType === "Fixed" && schemeInfo.toDate && receiptDate > schemeInfo.toDate) {
          alert(
            `The scheme "${schemeRecInfoData.schemeId?.[1]}" has expired on ${schemeInfo.toDate}.\nReceipts cannot be saved after the scheme end date.`
          );
          setSaveDisabled(false);
          return;
        }
        if (schemeInfo.fromDate && receiptDate < schemeInfo.fromDate) {
          alert(
            `Receipt date (${receiptDate}) is before the scheme "${schemeRecInfoData.schemeId?.[1]}" start date (${schemeInfo.fromDate}).\nReceipts must be within the scheme period.`
          );
          setSaveDisabled(false);
          return;
        }
      }

      if (
        !schemeRecInfoData.cashAcc ||
        !Array.isArray(schemeRecInfoData.cashAcc) ||
        schemeRecInfoData.cashAcc.length === 0
      ) {
        alert("Please select a Cash Account.");
        setSaveDisabled(false);
        return;
      }

      const validRows = [];
      const incompleteRows = [];

      tableData.forEach((row, index) => {
        const hasAnyData =
          row.name || row.accountNumber || row.amount || row.gm;

        if (hasAnyData) {
          const isComplete =
            row.name &&
            Array.isArray(row.name) &&
            row.name.length > 0 &&
            row.agent &&
            Array.isArray(row.agent) &&
            row.agent.length > 0 &&
            row.accountNumber &&
            Array.isArray(row.accountNumber) &&
            row.accountNumber.length > 0 &&
            row.amount &&
            row.amount !== "" &&
            parseFloat(row.amount) > 0;

          const rowHasScheme = row.schemeId || schemeRecInfoData.schemeId?.[0];

          if (isComplete && rowHasScheme) {
            validRows.push(row);
          } else {
            incompleteRows.push(index + 1);
          }
        }
      });

      if (incompleteRows.length > 0) {
        alert(
          `Please complete all required fields for row(s): ${incompleteRows.join(", ")}\n\nRequired fields: Account Number, Name, Agent, Amount`,
        );
        setSaveDisabled(false);
        return;
      }

      if (validRows.length === 0) {
        alert("Please enter at least one complete row of data to save.");
        setSaveDisabled(false);
        return;
      }

      // ── Row-level Scheme & Account Validation ──
      for (let i = 0; i < validRows.length; i++) {
        const row = validRows[i];
        if (!row.accountNumber) continue;

        const accNoVal = Array.isArray(row.accountNumber)
          ? row.accountNumber[1]
          : row.accountNumber;
        const accAutoVal = Array.isArray(row.accountNumber)
          ? row.accountNumber[0]
          : null;

        const matchedAcc = schemedatas.find(
          (item) =>
            (accAutoVal && item.auto === accAutoVal) || item.accno === accNoVal
        );

        const rowSchemeId = matchedAcc?.schemeId || row.schemeId;

        if (rowSchemeId && rowSchemeId !== selectedSchemeId) {
          const actualScheme = schemeNames.find((s) => s[0] === rowSchemeId);
          const actualSchemeName = actualScheme ? actualScheme[1] : `Scheme ID ${rowSchemeId}`;
          const currentSchemeName = schemeRecInfoData.schemeId?.[1] || "Selected Scheme";

          alert(
            `Account "${accNoVal}" belongs to scheme "${actualSchemeName}", not "${currentSchemeName}".\nReceipts can only contain accounts belonging to the selected scheme.`
          );
          setSaveDisabled(false);
          return;
        }

        if (rowSchemeId) {
          const accSchemeInfo = schemeDateMap[rowSchemeId];
          const receiptDate = schemeRecInfoData.date;

          let accountExpiryDate = matchedAcc?.ExpiryDate ? String(matchedAcc.ExpiryDate).substring(0, 10) : null;
          if (!accountExpiryDate && accSchemeInfo?.validityType === "Tenure" && matchedAcc?.Date && matchedAcc?.duration) {
            const d = new Date(matchedAcc.Date);
            if (accSchemeInfo?.schemeType === "Daily") {
              d.setDate(d.getDate() + Number(matchedAcc.duration));
            } else {
              d.setMonth(d.getMonth() + Number(matchedAcc.duration));
            }
            accountExpiryDate = d.toISOString().substring(0, 10);
          } else if (!accountExpiryDate && accSchemeInfo?.toDate) {
            accountExpiryDate = accSchemeInfo.toDate;
          }

          if (accountExpiryDate && receiptDate > accountExpiryDate) {
            alert(
              `The scheme for account "${accNoVal}" has expired on ${accountExpiryDate}.\nReceipts cannot be saved after the scheme end date.`
            );
            setSaveDisabled(false);
            return;
          }

          if (accSchemeInfo?.validityType === "Fixed" && accSchemeInfo?.toDate && receiptDate > accSchemeInfo.toDate) {
            alert(
              `The scheme for account "${accNoVal}" has expired on ${accSchemeInfo.toDate}.\nReceipts cannot be saved after the scheme end date.`
            );
            setSaveDisabled(false);
            return;
          }

          if (accSchemeInfo?.fromDate && receiptDate < accSchemeInfo.fromDate) {
            alert(
              `Receipt date (${receiptDate}) is before the start date (${accSchemeInfo.fromDate}) for account "${accNoVal}".`
            );
            setSaveDisabled(false);
            return;
          }
        }
      }

      const transformedTableData = validRows.map((row) => ({
        SINo: row.SINo || null,
        name: row.name[0] || null,
        agent: row.agent[0] || null,
        accountNumber: row.accountNumber[0] || null,
        amount: parseFloat(row.amount) || null,
        discount: parseFloat(row.disc) || 0,
        total: parseFloat(row.total) || parseFloat(row.amount) || null,
        gm: row.gm || null,
        discGm: row.discGm || 0,
        totalGm: row.totalGm || row.gm || null,
        narration: row.narration || null,
        printgm: row.printgm || 0,
        billed: row.billed || 0,
        schemeId: selectedSchemeId,
      }));

      const response = await axios.post(
        `${apiBaseUrl}/main/saveSchRec/${dbCode}`,
        {
          statementType: "SchRec_insert",
          cashacc: schemeRecInfoData.cashAcc[0],
          schemeId: schemeRecInfoData.schemeId[0],
          rate: Number(schemeRecInfoData.rate) || 0,
          date: schemeRecInfoData.date,
          salesMan: schemeRecInfoData.salesMan?.[0] || 0,
          totalamount: schemeRecInfoData.totalamt,
          totalDisc: schemeRecInfoData.totalDisc,
          totalamtdisc: schemeRecInfoData.totalamtdisc,
          totalgm: schemeRecInfoData.totalgm,
          totaldiscgm: schemeRecInfoData.totaldiscgm,
          agCode: parseInt(agentCode),
          formId: parseInt(frmId),
          fyid: fyid,
          Location: getCleanLocationId(schemeRecInfoData.Location),
          type: transformedTableData,
        },
      );

      if (response.data.success) {
        setSaveDisabled(false);

        const accountNumbers = transformedTableData.map(
          (row) => row.accountNumber,
        );
        const mobileNumbersResponse = await axios.post(
          `${apiBaseUrl}/main/fetchMobileNos/${dbCode}`,
          {
            accountNumbers,
          },
        );

        if (mobileNumbersResponse.data) {
          mobileNumbersResponse.data.forEach(async (mobileNumber) => {
            const customerData = transformedTableData.find(
              (row) => row.name === mobileNumber.accname,
            );

            if (customerData) {
              const total = formatSmsAmount(customerData.total || customerData.amount);
              const netwt = formatSmsWeight(mobileNumber.totalWt);
              const grandTotal = formatSmsAmount(mobileNumber.totalAmt);
              const gm = formatSmsWeight(customerData.totalGm || customerData.gm);
              const matchedAccNo = accNo.find((item) => item[0] === customerData.accountNumber)?.[1] || customerData.accountNumber;
              const matchedCustName = cnameData.find((item) => item[0] === mobileNumber.accname)?.[1] || "";

              const smsResponse = await sendSMS(
                matchedAccNo,
                mobileNumber.mobileNo,
                matchedCustName,
                total,
                grandTotal,
                netwt,
                gm,
              );

              const whatsappResponse = await sendWhatsAppMessage(
                matchedAccNo,
                mobileNumber.mobileNo,
                matchedCustName,
                total,
                grandTotal,
                netwt,
                gm,
              );
              console.log(
                `WhatsApp sent to ${mobileNumber.mobileNo}:`,
                whatsappResponse,
              );
            }
          });
        }

        alert("Entry Saved");
        setPrintSnapshot({
          tableData: JSON.parse(JSON.stringify(tableData)),
          schemeRecInfoData: { ...schemeRecInfoData },
          dispWt,
          dispTm,
        });
        openPrintDialog(true);
        setPrintDisabled(false);
      } else {
        alert("Failed to save data!");
        setSaveDisabled(false);
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      alert("Internal server error!");
      setSaveDisabled(false);
    }
  };
  const handleEdit = async () => {
    try {
      if (
        !schemeRecInfoData.schemeId ||
        !Array.isArray(schemeRecInfoData.schemeId) ||
        schemeRecInfoData.schemeId.length === 0
      ) {
        alert("Select Scheme Name.");
        return;
      }

      // ── Scheme date range validation ──
      const selectedSchemeId = schemeRecInfoData.schemeId?.[0];
      const schemeInfo = schemeDateMap[selectedSchemeId];
      if (schemeInfo) {
        const receiptDate = schemeRecInfoData.date; // "YYYY-MM-DD"
        if (schemeInfo.validityType === "Fixed" && schemeInfo.toDate && receiptDate > schemeInfo.toDate) {
          alert(
            `The scheme "${schemeRecInfoData.schemeId?.[1]}" has expired on ${schemeInfo.toDate}.\nReceipts cannot be edited after the scheme end date.`
          );
          return;
        }
        if (schemeInfo.fromDate && receiptDate < schemeInfo.fromDate) {
          alert(
            `Receipt date (${receiptDate}) is before the scheme "${schemeRecInfoData.schemeId?.[1]}" start date (${schemeInfo.fromDate}).\nReceipts must be within the scheme period.`
          );
          return;
        }
      }

      const billedRowsIndices = tableData
        .map((row, index) =>
          row.billed && row.billed !== 0 ? index + 1 : null,
        )
        .filter((index) => index !== null);

      if (billedRowsIndices.length > 0 && parseInt(userRights?.SRSMS) === 0) {
        const indicesStr = billedRowsIndices.join(", ");
        alert(`Row(s): ${indicesStr} are already transferred. Cannot Edit.`);
        return;
      }

      if (
        !schemeRecInfoData.cashAcc ||
        !Array.isArray(schemeRecInfoData.cashAcc) ||
        schemeRecInfoData.cashAcc.length === 0
      ) {
        alert("Please select a Cash Account.");
        return;
      }

      const validRows = [];
      const incompleteRows = [];

      tableData.forEach((row, index) => {
        const hasAnyData =
          row.name || row.accountNumber || row.amount || row.gm;

        if (hasAnyData) {
          const isComplete =
            row.name &&
            Array.isArray(row.name) &&
            row.name.length > 0 &&
            row.agent &&
            Array.isArray(row.agent) &&
            row.agent.length > 0 &&
            row.accountNumber &&
            Array.isArray(row.accountNumber) &&
            row.accountNumber.length > 0 &&
            row.amount &&
            row.amount !== "" &&
            parseFloat(row.amount) > 0;

          const rowHasScheme = row.schemeId || schemeRecInfoData.schemeId?.[0];

          if (isComplete && rowHasScheme) {
            validRows.push(row);
          } else {
            incompleteRows.push(index + 1);
          }
        }
      });

      if (incompleteRows.length > 0) {
        alert(
          `Please complete all required fields for row(s): ${incompleteRows.join(", ")}`,
        );
        return;
      }

      if (validRows.length === 0) {
        alert("No valid data to edit.");
        return;
      }

      // ── Row-level Scheme & Account Validation ──
      for (let i = 0; i < validRows.length; i++) {
        const row = validRows[i];
        if (!row.accountNumber) continue;

        const accNoVal = Array.isArray(row.accountNumber)
          ? row.accountNumber[1]
          : row.accountNumber;
        const accAutoVal = Array.isArray(row.accountNumber)
          ? row.accountNumber[0]
          : null;

        const matchedAcc = schemedatas.find(
          (item) =>
            (accAutoVal && item.auto === accAutoVal) || item.accno === accNoVal
        );

        const rowSchemeId = matchedAcc?.schemeId || row.schemeId;

        if (rowSchemeId && rowSchemeId !== selectedSchemeId) {
          const actualScheme = schemeNames.find((s) => s[0] === rowSchemeId);
          const actualSchemeName = actualScheme ? actualScheme[1] : `Scheme ID ${rowSchemeId}`;
          const currentSchemeName = schemeRecInfoData.schemeId?.[1] || "Selected Scheme";

          alert(
            `Account "${accNoVal}" belongs to scheme "${actualSchemeName}", not "${currentSchemeName}".\nReceipts can only contain accounts belonging to the selected scheme.`
          );
          return;
        }

        if (rowSchemeId) {
          const accSchemeInfo = schemeDateMap[rowSchemeId];
          const receiptDate = schemeRecInfoData.date;

          let accountExpiryDate = matchedAcc?.ExpiryDate ? String(matchedAcc.ExpiryDate).substring(0, 10) : null;
          if (!accountExpiryDate && accSchemeInfo?.validityType === "Tenure" && matchedAcc?.Date && matchedAcc?.duration) {
            const d = new Date(matchedAcc.Date);
            if (accSchemeInfo?.schemeType === "Daily") {
              d.setDate(d.getDate() + Number(matchedAcc.duration));
            } else {
              d.setMonth(d.getMonth() + Number(matchedAcc.duration));
            }
            accountExpiryDate = d.toISOString().substring(0, 10);
          } else if (!accountExpiryDate && accSchemeInfo?.toDate) {
            accountExpiryDate = accSchemeInfo.toDate;
          }

          if (accountExpiryDate && receiptDate > accountExpiryDate) {
            alert(
              `The scheme for account "${accNoVal}" has expired on ${accountExpiryDate}.\nReceipts cannot be edited after the scheme end date.`
            );
            return;
          }

          if (accSchemeInfo?.validityType === "Fixed" && accSchemeInfo?.toDate && receiptDate > accSchemeInfo.toDate) {
            alert(
              `The scheme for account "${accNoVal}" has expired on ${accSchemeInfo.toDate}.\nReceipts cannot be edited after the scheme end date.`
            );
            return;
          }

          if (accSchemeInfo?.fromDate && receiptDate < accSchemeInfo.fromDate) {
            alert(
              `Receipt date (${receiptDate}) is before the start date (${accSchemeInfo.fromDate}) for account "${accNoVal}".`
            );
            return;
          }
        }
      }

      const transformedTableData = validRows.map((row) => ({
        SINo: row.SINo || null,
        name: row.name[0] || null,
        agent: row.agent[0] || null,
        accountNumber: row.accountNumber[0] || null,
        amount: parseFloat(row.amount) || null,
        discount: parseFloat(row.disc) || 0,
        total: parseFloat(row.total) || parseFloat(row.amount) || null,
        gm: row.gm || null,
        discGm: row.discGm || 0,
        totalGm: row.totalGm || row.gm || null,
        narration: row.narration || null,
        printgm: row.printgm || 0,
        billed: row.billed || 0,
        schemeId: selectedSchemeId,
      }));

      const response = await axios.post(
        `${apiBaseUrl}/main/updateSchRec/${dbCode}`,
        {
          statementType: "SchRec_edit",
          cashacc: schemeRecInfoData.cashAcc[0],
          schemeId: schemeRecInfoData.schemeId[0],
          rate: Number(schemeRecInfoData.rate) || 0,
          date: schemeRecInfoData.date,
          salesMan: schemeRecInfoData.salesMan?.[0] || 0,
          totalamount: schemeRecInfoData.totalamt,
          totalDisc: schemeRecInfoData.totalDisc,
          totalamtdisc: schemeRecInfoData.totalamtdisc,
          totalgm: schemeRecInfoData.totalgm,
          totaldiscgm: schemeRecInfoData.totaldiscgm,
          agCode: parseInt(agentCode),
          formId: parseInt(frmId),
          fyid: fyid,
          Location: getCleanLocationId(schemeRecInfoData.Location),
          EntryNo: schemeRecInfoData.EntryNo,
          type: transformedTableData,
        },
      );

      if (response.data.success) {
        handleClear();
        alert("Entry Edited Successfully!");
        setShowFind(true);
      } else {
        alert("Failed to edit data!");
      }
    } catch (error) {
      console.error("Error edit data:", error.message);
      alert("Internal server error!");
    }
  };

  return (
    <div className="SchemeCashReceiptMobRoot box-border">
      <div className="SchemeCashReceiptMobnavBar box-border p-2">
        <div
          className=""
          onClick={() => {
            navigate("/home");
            setdispWt("");
          }}
        >
          <img src={home} alt="X" />
        </div>
        <div className="min-w-14 flex items-center justify-center gap-1 ml-auto mr-auto">
          <img src={sslogo} alt="SS" />
          <label className="text-white whitespace-nowrap">Scheme Receipt</label>
        </div>

        {showFind ? (
          <div className="scherecmobnavitems">
            <button
              className="SchemeRecMobnavBaritemsbuttons"
              onClick={handleClear}
              ref={registerRef("ClearBtn")}
            >
              <img src={clear} alt="Clear" className="SchemeRecMobbuttonimg" />
            </button>
            {permissions["schemecashReceipt"]?.actions.Save && (
              <button
                className="SchemeRecMobnavBaritemsbuttons"
                onClick={handleSave}
                ref={(el) => {
                  registerRef("SaveBtn")(el);
                  saveButtonRef.current = el;
                }}
                disabled={saveDisabled}
              >
                <img src={save} alt="Save" className="SchemeRecMobbuttonimg" />
              </button>
            )}
            <button
              className="SchemeRecMobnavBaritemsbuttons"
              ref={(el) => {
                registerRef("PrintBtn")(el);
                printButtonRef.current = el;
              }}
              disabled={printDisabled}
              onClick={handlePrint}
            >
              <img src={print} alt="Print" className="SchemeRecMobbuttonimg" />
            </button>
            {permissions["schemecashReceipt"]?.actions.Find && (
              <button
                className="SchemeRecMobnavBaritemsbuttons"
                onClick={openFindDialog}
                ref={registerRef("FindBtn")}
              >
                <img src={find} alt="Find" className="SchemeRecMobbuttonimg" />
              </button>
            )}
          </div>
        ) : (
          <div className="scherecmobnavitems">
            <button
              className="SchemeRecMobnavBaritemsbuttons"
              ref={(el) => {
                registerRef("PrintBtn")(el);
                printButtonRef.current = el;
              }}
              onClick={handlePrint}
            >
              <img src={print} alt="Print" className="SchemeRecMobbuttonimg" />
            </button>
            <button
              className="SchemeRecMobnavBaritemsbuttons"
              onClick={handleClear}
              ref={registerRef("ClearBtn")}
            >
              <img src={clear} alt="Clear" className="SchemeRecMobbuttonimg" />
            </button>
            {permissions["schemecashReceipt"]?.actions.Edit && (
              <button
                className="SchemeRecMobnavBaritemsbuttons"
                onClick={handleEdit}
                disabled={editDisabled || userType !== "ADMIN"}
                ref={registerRef("EditBtn")}
              >
                <img src={edit} alt="Edit" className="SchemeRecMobbuttonimg" />
              </button>
            )}
            {permissions["schemecashReceipt"]?.actions.Delete && (
              <button
                className="SchemeRecMobnavBaritemsbuttons"
                onClick={handleDelete}
                disabled={deleteDisabled || userType !== "ADMIN"}
                ref={registerRef("DeleteBtn")}
              >
                <img
                  src={Delete}
                  alt="Delete"
                  className="SchemeRecMobbuttonimg"
                />
              </button>
            )}
          </div>
        )}
      </div>

      <div className="schemeRecMobBody gap-3">
        <div className="schemeRecMobBodySec1 h-auto box-border py-2">
          <div className="schemeRecMobBodySec1Rowtop">
            <div className="schemeRecMobBodySec1RowCol" style={getContainerStyle("EntryNo")}>
              <label htmlFor="" style={getLabelStyle("EntryNo")}>Entry No</label>
              <input
                type="number"
                ref={(el) => {
                  registerRef("EntryNo")(el);
                  entryNoInputRef.current = el;
                }}
                onKeyDown={(e) => handleDynamicKeyDown(e, "EntryNo")}
                readOnly={isFieldReadOnly("EntryNo")}
                style={getInputStyle("EntryNo", { textAlign: "center" })}
                value={schemeRecInfoData.EntryNo}
                onChange={(e) =>
                  setschemeRecInfoData({
                    ...schemeRecInfoData,
                    EntryNo: e.target.value,
                  })
                }
              />
            </div>
            <div className="schemeRecMobBodySec1RowCol" style={getContainerStyle("Date")}>
              <label htmlFor="" className="datelabel" style={getLabelStyle("Date")}>
                Date
              </label>
              <input
                type="date"
                className="dateinput"
                min={minDate}
                max={maxDate}
                value={schemeRecInfoData.date}
                ref={(el) => {
                  registerRef("Date")(el);
                  dateInputRef.current = el;
                }}
                onKeyDown={(e) => handleDynamicKeyDown(e, "Date")}
                readOnly={
                  (userType === "EMPLOYEE" && genValues?.readonlyDate === 1) ||
                  isFieldReadOnly("Date")
                }
                style={getInputStyle("Date")}
                onChange={(e) => {
                  setschemeRecInfoData({
                    ...schemeRecInfoData,
                    date: e.target.value,
                  });
                }}
                onBlur={(e) => {
                  const val = e.target.value;
                  if (val && !isDateInFy(val)) {
                    alert("Date incompatible with financial year");
                  }
                }}
              />
            </div>
          </div>
          <div className="schemeRecMobBodySec1Row" style={getContainerStyle("SchemeName")}>
            <label htmlFor="" style={getLabelStyle("SchemeName")}>Scheme Name</label>
            <ComboBox
              className="scheRecMobCashAccCombo"
              inputClassName="comboInputPadding"
              options={schemeNames}
              comboRef={(el) => {
                registerRef("SchemeName")(el);
                schemIdinputRef.current = el;
              }}
              onKeyDown={(e) => handleDynamicKeyDown(e, "SchemeName")}
              findedValue={
                Array.isArray(schemeRecInfoData.schemeId)
                  ? schemeRecInfoData.schemeId[1]
                  : schemeRecInfoData.schemeId
              }
              onInputChange={(e) => {
                handleSchemeChange(e);
              }}
              inlineStyles={getInputStyle("SchemeName")}
              disabled={isFieldDisabled("SchemeName")}
            />
          </div>
          <div className="schemeRecMobBodySec1Row" style={getContainerStyle("CashAccount")}>
            <label htmlFor="" style={getLabelStyle("CashAccount")}>Select Cash Account</label>
            <ComboBox
              className="scheRecMobCashAccCombo"
              inputClassName="comboInputPadding"
              options={selectcashAcc}
              comboRef={(el) => {
                registerRef("CashAccount")(el);
                cashaccinputRef.current = el;
              }}
              onKeyDown={(e) => {
                handleDynamicKeyDown(e, "CashAccount");
                checkledgerExists(e);
              }}
              findedValue={
                Array.isArray(schemeRecInfoData.cashAcc)
                  ? schemeRecInfoData.cashAcc[1]
                  : schemeRecInfoData.cashAcc
              }
              onInputChange={(e) =>
                setschemeRecInfoData({ ...schemeRecInfoData, cashAcc: e })
              }
              inlineStyles={getInputStyle("CashAccount")}
              disabled={isFieldDisabled("CashAccount")}
            />
          </div>
          <div className="schemeRecMobBodySec1Row" style={getContainerStyle("Rate")}>
            <label htmlFor="" style={getLabelStyle("Rate")}>Rate</label>
            <input
              ref={(el) => {
                registerRef("Rate")(el);
                rateInputRef.current = el;
              }}
              onKeyDown={(e) => handleDynamicKeyDown(e, "Rate")}
              value={schemeRecInfoData.rate}
              type="number"
              onChange={(e) =>
                setschemeRecInfoData({
                  ...schemeRecInfoData,
                  rate: e.target.value,
                })
              }
              style={getInputStyle("Rate", { textAlign: "right" })}
              readOnly={
                (userType === "EMPLOYEE" && genValues?.readonlyGrate === 1) ||
                isFieldReadOnly("Rate")
              }
              disabled={isFieldDisabled("Rate")}
            />
          </div>
        </div>
        <div className="schemeRecMobBodySec2">
          {isColumnVisible("AccountNumber") && isFieldVisible("grid_AccountNumber") && (
            <div className="schemeRecMobBodySec2Row" style={getContainerStyle("grid_AccountNumber")}>
              <label htmlFor="" style={getLabelStyle("grid_AccountNumber")}>Account Number</label>
              <ComboBox
                className="scheRecMobCashAccCombo"
                inputClassName="comboInputPadding"
                options={filteredaccNo}
                comboRef={registerRef("grid_0_AccountNumber")}
                onKeyDown={(e) => {
                  handleDynamicKeyDown(e, "grid_0_AccountNumber");
                  checkAccnoExists(e);
                }}
                findedValue={
                  Array.isArray(tableData[0]?.accountNumber)
                    ? (tableData[0]?.accountNumber?.[1] ?? "")
                    : tableData[0]?.accountNumber
                }
                onInputChange={(e) => {
                  handleCellChange(e, 0, "accountNumber");
                  if (e && Array.isArray(e) && e.length > 0) {
                    fetchAccNoData(e, 0);
                  }
                }}
                disabled={
                  !schemeRecInfoData.schemeId ||
                  !Array.isArray(schemeRecInfoData.schemeId) ||
                  schemeRecInfoData.schemeId.length === 0 ||
                  isFieldDisabled("grid_AccountNumber")
                }
                inlineStyles={getInputStyle("grid_AccountNumber", { textAlign: "right" })}
              />
            </div>
          )}
          {isColumnVisible("ItemName") && isFieldVisible("grid_ItemName") && (
            <div className="schemeRecMobBodySec2Row" style={getContainerStyle("grid_ItemName")}>
              <label htmlFor="" style={getLabelStyle("grid_ItemName")}>Name</label>
              <ComboBox
                className="scheRecMobCashAccCombo"
                inputClassName="comboInputPadding"
                options={cnameData}
                comboRef={registerRef("grid_0_ItemName")}
                onKeyDown={(e) => {
                  handleDynamicKeyDown(e, "grid_0_ItemName");
                  checkNameExists(e);
                }}
                findedValue={
                  Array.isArray(tableData[0]?.name)
                    ? (tableData[0]?.name?.[1] ?? "")
                    : tableData[0]?.name
                }
                onInputChange={(e) => {
                  handleCellChange(e, 0, "name");
                  if (e && Array.isArray(e) && e.length > 0) {
                    fetchAccNmData(e, 0);
                  }
                }}
                disabled={
                  !schemeRecInfoData.schemeId ||
                  !Array.isArray(schemeRecInfoData.schemeId) ||
                  schemeRecInfoData.schemeId.length === 0 ||
                  isFieldDisabled("grid_ItemName")
                }
                inlineStyles={getInputStyle("grid_ItemName")}
              />
            </div>
          )}
          {isColumnVisible("Agent") && isFieldVisible("grid_Agent") && (
            <div className="schemeRecMobBodySec2Row" style={getContainerStyle("grid_Agent")}>
              <label htmlFor="" style={getLabelStyle("grid_Agent")}>Agent</label>
              <ComboBox
                className="scheRecMobCashAccCombo"
                inputClassName="comboInputPadding"
                options={agentName}
                comboRef={registerRef("grid_0_Agent")}
                onKeyDown={(e) => handleDynamicKeyDown(e, "grid_0_Agent")}
                findedValue={
                  Array.isArray(tableData[0]?.agent)
                    ? (tableData[0]?.agent?.[1] ?? "")
                    : tableData[0]?.agent
                }
                onInputChange={(e) => handleCellChange(e, 0, "agent")}
                readOnly={true}
                disabled={
                  !schemeRecInfoData.schemeId ||
                  !Array.isArray(schemeRecInfoData.schemeId) ||
                  schemeRecInfoData.schemeId.length === 0 ||
                  isFieldDisabled("grid_Agent")
                }
                inlineStyles={getInputStyle("grid_Agent")}
              />
            </div>
          )}
          {isColumnVisible("Amount") && isFieldVisible("grid_Amount") && (
            <div className="schemeRecMobBodySec2Row" style={getContainerStyle("grid_Amount")}>
              <label htmlFor="" style={getLabelStyle("grid_Amount")}>Amount</label>
              <input
                type="number" 
                ref={registerRef("grid_0_Amount")}
                onKeyDown={(e) => handleDynamicKeyDown(e, "grid_0_Amount")}
                value={tableData[0]["amount"]}
                style={getInputStyle("grid_0_Amount", { textAlign: "right" })}
                onChange={(e) => {
                  handleCellChangeinput(e, 0, "amount");
                  const updated = [...tableData];
                  updated[0].amount = e.target.value;
                  calculateRowTotalAndGms(0, updated);
                }}
                onBlur={() => calculateRowTotalAndGms(0)}
                readOnly={isFieldReadOnly("grid_Amount")}
                disabled={
                  !schemeRecInfoData.schemeId ||
                  !Array.isArray(schemeRecInfoData.schemeId) ||
                  schemeRecInfoData.schemeId.length === 0 ||
                  isFieldDisabled("grid_Amount")
                }
              />
            </div>
          )}
          {isColumnVisible("Disc") && isFieldVisible("grid_Disc") && (
            <div className="schemeRecMobBodySec2Row" style={getContainerStyle("grid_Disc")}>
              <label htmlFor="" style={getLabelStyle("grid_Disc")}>Disc</label>
              <input
                type="number"
                ref={registerRef("grid_0_Disc")}
                onKeyDown={(e) => handleDynamicKeyDown(e, "grid_0_Disc")}
                value={tableData[0]["disc"]}
                style={getInputStyle("grid_0_Disc", { textAlign: "right" })}
                onChange={(e) => {
                  handleCellChangeinput(e, 0, "disc");
                  const updated = [...tableData];
                  updated[0].disc = e.target.value;
                  calculateRowTotalAndGms(0, updated);
                }}
                onBlur={() => calculateRowTotalAndGms(0)}
                readOnly={isFieldReadOnly("grid_Disc")}
                disabled={
                  !schemeRecInfoData.schemeId ||
                  !Array.isArray(schemeRecInfoData.schemeId) ||
                  schemeRecInfoData.schemeId.length === 0 ||
                  isFieldDisabled("grid_Disc")
                }
              />
            </div>
          )}
          {isColumnVisible("Total") && isFieldVisible("grid_Total") && (
            <div className="schemeRecMobBodySec2Row" style={getContainerStyle("grid_Total")}>
              <label htmlFor="" style={getLabelStyle("grid_Total")}>Total</label>
              <input
                type="number"
                ref={registerRef("grid_0_Total")}
                onKeyDown={(e) => handleDynamicKeyDown(e, "grid_0_Total")}
                readOnly
                value={tableData[0]["total"]}
                style={getInputStyle("grid_0_Total", { textAlign: "right" })}
                disabled={
                  !schemeRecInfoData.schemeId ||
                  !Array.isArray(schemeRecInfoData.schemeId) ||
                  schemeRecInfoData.schemeId.length === 0 ||
                  isFieldDisabled("grid_Total")
                }
              />
            </div>
          )}
          {isColumnVisible("Gm") && isFieldVisible("grid_Gm") && (
            <div className="schemeRecMobBodySec2Row" style={getContainerStyle("grid_Gm")}>
              <label htmlFor="" style={getLabelStyle("grid_Gm")}>Gm</label>
              <input
                ref={registerRef("grid_0_Gm")}
                onKeyDown={(e) => handleDynamicKeyDown(e, "grid_0_Gm")}
                readOnly
                value={tableData[0]["gm"]}
                style={getInputStyle("grid_0_Gm", { textAlign: "right" })}
                disabled={
                  !schemeRecInfoData.schemeId ||
                  !Array.isArray(schemeRecInfoData.schemeId) ||
                  schemeRecInfoData.schemeId.length === 0 ||
                  isFieldDisabled("grid_Gm")
                }
              />
            </div>
          )}
          {isColumnVisible("DiscGm") && isFieldVisible("grid_DiscGm") && (
            <div className="schemeRecMobBodySec2Row" style={getContainerStyle("grid_DiscGm")}>
              <label htmlFor="" style={getLabelStyle("grid_DiscGm")}>Disc Gm</label>
              <input
                ref={registerRef("grid_0_DiscGm")}
                onKeyDown={(e) => handleDynamicKeyDown(e, "grid_0_DiscGm")}
                readOnly
                value={tableData[0]["discGm"]}
                style={getInputStyle("grid_0_DiscGm", { textAlign: "right" })}
                disabled={
                  !schemeRecInfoData.schemeId ||
                  !Array.isArray(schemeRecInfoData.schemeId) ||
                  schemeRecInfoData.schemeId.length === 0 ||
                  isFieldDisabled("grid_DiscGm")
                }
              />
            </div>
          )}
          {isColumnVisible("TotalGm") && isFieldVisible("grid_TotalGm") && (
            <div
              className="schemeRecMobBodySec2Row"
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "95%",
                gap: "10px",
                ...getContainerStyle("grid_TotalGm")
              }}
            >
              <div style={{ flex: 1, display: "flex", flexDirection: "column", width: "100%" }}>
                <label htmlFor="" style={getLabelStyle("grid_TotalGm")}>Total Gm</label>
                <input
                  ref={registerRef("grid_0_TotalGm")}
                  onKeyDown={(e) => handleDynamicKeyDown(e, "grid_0_TotalGm")}
                  readOnly
                  value={tableData[0]["totalGm"]}
                  style={getInputStyle("grid_0_TotalGm", { textAlign: "right", width: "100%", boxSizing: "border-box", padding: "0 10px" })}
                  disabled={
                    !schemeRecInfoData.schemeId ||
                    !Array.isArray(schemeRecInfoData.schemeId) ||
                    schemeRecInfoData.schemeId.length === 0 ||
                    isFieldDisabled("grid_TotalGm")
                  }
                />
              </div>
              {isColumnVisible("PrintGm") && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                    paddingBottom: "5px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <input
                    ref={(el) => {
                      registerRef("grid_0_PrintGm")(el);
                      printgmRef.current = el;
                    }}
                    onKeyDown={(e) => handleDynamicKeyDown(e, "grid_0_PrintGm")}
                    checked={tableData[0]["printgm"] === 1}
                    type="checkbox"
                    style={{ width: "auto", margin: 0 }}
                    onChange={(e) => handleCellChangeinput(e, 0, "printgm")}
                    disabled={
                      !schemeRecInfoData.schemeId ||
                      !Array.isArray(schemeRecInfoData.schemeId) ||
                      schemeRecInfoData.schemeId.length === 0
                    }
                  />
                  <label htmlFor="" style={{ width: "auto", margin: 0, fontSize: "12px" }}>
                    Print Gm
                  </label>
                </div>
              )}
            </div>
          )}
          <div className="schemeRecMobBodySec2Row">
            <label htmlFor="">CW</label>
            <input type="number" value={dispWt} readOnly />
          </div>
          <div className="schemeRecMobBodySec2Row">
            <label htmlFor="">CB</label>
            <input type="number" value={dispTm} readOnly />
          </div>

          {isColumnVisible("Narration") && isFieldVisible("grid_Narration") && (
            <div className="schemeRecMobBodySec2Row2" style={getContainerStyle("grid_Narration")}>
              <label htmlFor="" style={getLabelStyle("grid_Narration")}>Narration</label>
              <input
                type="text"
                ref={registerRef("grid_0_Narration")}
                onKeyDown={(e) => handleDynamicKeyDown(e, "grid_0_Narration")}
                value={tableData[0]["narration"]}
                onChange={(e) => handleCellChangeinput(e, 0, "narration")}
                style={getInputStyle("grid_0_Narration")}
                disabled={
                  !schemeRecInfoData.schemeId ||
                  !Array.isArray(schemeRecInfoData.schemeId) ||
                  schemeRecInfoData.schemeId.length === 0 ||
                  isFieldDisabled("grid_Narration")
                }
              />
            </div>
          )}
        </div>
      </div>

      {showFindDialog && (
        <div className="find_dialog_scheRecMob">
          <input
            type="text"
            value={findEntryNo}
            onChange={(e) => setFindEntryNo(e.target.value)}
            placeholder="Enter Entry No"
          />
          <button onClick={handleFindbyentrynumber}>Find</button>
          <div
            className="findCloseDiv"
            onClick={() => {
              closeFindDialog();
              handleClear();
            }}
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <img
              src={close}
              alt="Close"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </div>
      )}

      {showPrintDialog && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "16px",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
              padding: "24px 20px",
              width: "100%",
              maxWidth: "340px",
              display: "flex",
              flexDirection: "column",
              gap: "14px",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span style={{ fontWeight: 700, fontSize: "16px", color: "#0f2d59" }}>🖨️ Print Receipt</span>
              <button
                onClick={closePrintDialog}
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: "18px", color: "#64748b", lineHeight: 1 }}
              >✕</button>
            </div>

            {/* Sl No Input */}
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Row Sl No</label>
              <input
                type="number"
                min="1"
                value={selectedSlNo}
                onChange={(e) => setSelectedSlno(e.target.value)}
                placeholder="e.g. 1"
                autoFocus
                style={{
                  border: "1.5px solid #cbd5e1", borderRadius: "7px",
                  padding: "8px 12px", fontSize: "14px", outline: "none",
                  width: "100%", boxSizing: "border-box",
                }}
              />
            </div>

            {/* Action Buttons */}
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "4px" }}>
              {/* Print */}
              <button
                disabled={isPrintLoading}
                onClick={() => handleDynamicAction("print")}
                style={{
                  background: isPrintLoading ? "#94a3b8" : "linear-gradient(135deg,#0f56d3,#0f2d59)",
                  color: "#fff", border: "none", borderRadius: "8px",
                  padding: "12px 16px", fontSize: "14px", fontWeight: 600,
                  cursor: isPrintLoading ? "not-allowed" : "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                  transition: "opacity 0.2s",
                }}
              >
                🖨️ {isPrintLoading ? "Generating..." : "Print Receipt"}
              </button>

              {/* Download PDF */}
              <button
                disabled={isPrintLoading}
                onClick={() => handleDynamicAction("download")}
                style={{
                  background: isPrintLoading ? "#94a3b8" : "linear-gradient(135deg,#059669,#065f46)",
                  color: "#fff", border: "none", borderRadius: "8px",
                  padding: "12px 16px", fontSize: "14px", fontWeight: 600,
                  cursor: isPrintLoading ? "not-allowed" : "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                  transition: "opacity 0.2s",
                }}
              >
                📥 {isPrintLoading ? "Generating..." : "Download PDF"}
              </button>
            </div>

            {isPrintLoading && (
              <p style={{ textAlign: "center", fontSize: "12px", color: "#94a3b8", margin: 0 }}>
                Building PDF from template…
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function SchemeCashReceiptMob() {
  const { dbCode } = useDbContext();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();

  if (location.state?.fId) {
    sessionStorage.setItem("selectedSchemeReceipt_fId", String(location.state.fId));
    if (location.state.abbreviation) {
      sessionStorage.setItem("selectedSchemeReceipt_abbreviation", location.state.abbreviation);
    }
    if (location.state.typeOfVoucher) {
      sessionStorage.setItem("selectedSchemeReceipt_typeOfVoucher", location.state.typeOfVoucher);
    }
  }

  const fId =
    location.state?.fId ||
    sessionStorage.getItem("selectedSchemeReceipt_fId");
  const abbreviation =
    location.state?.abbreviation ||
    sessionStorage.getItem("selectedSchemeReceipt_abbreviation") ||
    "";
  const typeOfVoucher =
    location.state?.typeOfVoucher ||
    sessionStorage.getItem("selectedSchemeReceipt_typeOfVoucher") ||
    abbreviation ||
    "SCHEME RECEIPT";

  return (
    <FormDesignProvider
      formName={typeOfVoucher}
      defaultFields={defaultSchemeFormFields}
      dbCode={dbCode}
      apiBaseUrl={apiBaseUrl}
    >
      <SchemeCashReceiptInnerMob
        formId={fId}
        formName={abbreviation}
        voucherType={typeOfVoucher}
      />
    </FormDesignProvider>
  );
}

export default SchemeCashReceiptMob;
